import React, { useContext, useState } from "react";
import { PageLayout, Separator, Text } from "components";
import { useMeeting } from "../hooks";
import {
  MeetingListCardStyle,
  MeetingCalendarStyle,
  CalendarContainerStyle,
  CalendarContainerMobileStyle,
} from "../styles";
import { UserContext } from "context";
import { EActivityEvent } from "types";
import { recordActivity } from "services";
import { useNavigate } from "react-router-dom";
import { E_Route } from "utils/constants";
import Calendar from "react-calendar";
import DatePicker from "react-date-picker";
import "../styles/DatePicker.css";
import "../styles/Calendar.css";
import { CardBase, MeetingListItem } from "../components";
import { Value } from "react-calendar/dist/cjs/shared/types";
import { CalendarBlankIcon, CloseIcon } from "components/icons";
import { css } from "@emotion/css";

const next2Weeks = new Date();
next2Weeks.setDate(next2Weeks.getDate() + 14);

export const CalendarScreen = () => {
  const { state: userState } = useContext(UserContext);
  const [value, onDateChange] = useState<Value>(new Date());
  const { allMeetings, loading, externalMeetings } = useMeeting(
    value ? new Date(value.toString()).getTime() : undefined,
  );

  const navigate = useNavigate();

  const handleMeetingClick = (id: string) => {
    const meeting = externalMeetings?.find(
      (m) => m.meetingId === id || m._id === id,
    );
    if (meeting) {
      if (userState?._id) {
        recordActivity({
          data: {
            user: userState?._id,
            event: EActivityEvent.MeetingPrepClicked,
            source: "web",
            data: {
              meetingId: id,
              startAt: meeting.startAt,
            },
          },
        });
      }

      navigate(`${E_Route.Meeting}/${id}`);
    } else {
      //navigate(`${E_Route.Meeting}/${id}?internal=yes`);
    }
  };

  return (
    <PageLayout title="Meetings | Multiplayer">
      <div className={MeetingCalendarStyle}>
        <div
          className={css`
            display: none;
            @media (max-width: 768px) {
              display: block;
            }
          `}
        >
          <Text.H3>Your meeting prep at a specific day</Text.H3>
          <Separator.Horizontal spacing={4} />
        </div>
        <div className={CalendarContainerStyle}>
          <Calendar
            onChange={onDateChange}
            value={value}
            maxDate={next2Weeks}
            maxDetail="month"
            minDetail="month"
            next2Label={null}
            prev2Label={null}
          />
        </div>
        <div className={CalendarContainerMobileStyle}>
          <DatePicker
            onChange={onDateChange}
            value={value}
            maxDate={next2Weeks}
            maxDetail="month"
            calendarIcon={<CalendarBlankIcon fill="primary" />}
            clearIcon={<CloseIcon fill="#fff" />}
          />
        </div>
        <Separator.Vertical spacing={4} />
        <CardBase className={MeetingListCardStyle}>
          {loading && <Text.Body>Loading...</Text.Body>}
          {allMeetings.map((meeting, idx, all) => (
            <React.Fragment key={meeting.id}>
              <MeetingListItem
                title={meeting.title}
                startTime={meeting.startAt || "Unknown"}
                type={meeting.label || "External"}
                onClick={() => {
                  handleMeetingClick(meeting.id);
                }}
              />
              {idx !== all.length - 1 && (
                <Separator.Horizontal border spacing={1} />
              )}
            </React.Fragment>
          ))}
          {!allMeetings.length && !loading && (
            <Text.Body>Nothing on your agenda!</Text.Body>
          )}
        </CardBase>
      </div>
    </PageLayout>
  );
};
